import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import DialogSellDetail from './detail/tab-details';
import { Typography } from '@mui/material';
import SellWork from './work/tab-works';
import TabPays from './pay/tab-pays';
import { blue } from '@mui/material/colors';
import { useAuth } from '../../../hooks/useAuth';



export default function ProjectTabs({userClient, ReqUser}) {
    const { authData } = useAuth()
    const [value, setValue] = useState('1')
    const [isAdmin, setIsAdmin] = useState(false)

    useEffect(()=>{
        // console.log("SellWork", ReqUser.sell_req_buys.sell_mats)
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        
    }, [authData])

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

  return (
    <Box 
        sx={{ 
            width: '100%', 
            typography: 'body' 
        }}>
        <TabContext value={value}>
            <Box 
                sx={{ 
                    borderBottom: 1, 
                    borderColor: 'divider',
                    backgroundColor: blue[700]
                }}>
                <TabList 
                    onChange={handleChange} 
                    aria-label="tabs answer"
                    indicatorColor="secondary"
                    textColor="secondary"
                    >
                    <Tab 
                        label={(
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                مراحل پروژه
                            </Typography>
                        )}
                        value="1" />
                    <Tab 
                        label={(
                            <Typography
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                color={'pink.text'}
                                >
                                وضعیت پروژه
                            </Typography>
                        )}
                        value="2" 
                        />
                    {isAdmin &&
                        <Tab 
                            label={(
                                <Typography
                                    fontFamily='b_mitra' 
                                    component="div"
                                    variant="h6"
                                    color={'pink.text'}
                                    >
                                    پرداخت ها
                                </Typography>
                            )}
                            value="3" />
                    }
                </TabList>
            </Box>
            <TabPanel value="1">
                <DialogSellDetail userClient={userClient} ReqUser={ReqUser}/>
            </TabPanel>
            <TabPanel value="2">
                <SellWork userClient={userClient} ReqUser={ReqUser}/>
            </TabPanel>
            {isAdmin &&
                <TabPanel value="3">
                    <TabPays userClient={userClient} ReqUser={ReqUser}/>
                </TabPanel>
            }
        </TabContext>
    </Box>
    )
}